export default "__VITE_ASSET__5ex3_I0C__"